module.exports = __webpack_public_path__ + "img/main_macbook.1aa40125.png";